"use strict";

import $ from 'jquery';

export function initInScope($scope) {

    const rowsPerPage = 10;
    let currentPage = 1;
    let filteredRows = [];

    const allRows = Array.from($scope.find('.job-row'));
    const paginationContainer = $scope.find('#pagination-container')[0];
    const prevBtn = $scope.find('#prev-page')[0];
    const nextBtn = $scope.find('#next-page')[0];
    const currentPageEl = $scope.find('#current-page')[0];
    const totalPagesEl = $scope.find('#total-pages')[0];
    const noJobsRow = $scope.find('#no-jobs-row')[0];
    const departmentBtn = $scope.find('#departmentDropdown');
    const locationBtn = $scope.find('#locationDropdown');

    $scope.find('.filter-dropdown-btn').each(function() {
        const $btn = $(this);
        $btn.on('click', function (e) {
            e.stopPropagation();

            const menuId = $btn.attr('id').replace('Dropdown', '-menu');
            const $menu = $scope.find('#' + menuId);

            $scope.find('.filter-dropdown-menu').each(function() {
                if (this !== $menu[0]) {
                    $(this).removeClass('show');
                }
            });

            $menu.toggleClass('show');
        });
    });

    $(document).on('click.recruiteeFilter', function () {
        $scope.find('.filter-dropdown-menu').removeClass('show');
    });

    $scope.on('click', '.filter-dropdown-menu .dropdown-item', function (e) {
        e.preventDefault();

        const $item = $(this);
        const $menu = $item.closest('.filter-dropdown-menu');
        const btnId = $menu.attr('aria-labelledby');
        const $btn = $scope.find('#' + btnId);
        const $labelSpan = $btn.length ? $scope.find('#' + $btn.attr('id').replace('Dropdown', '-label')) : $();

        if ($labelSpan.length) $labelSpan.text($item.text().trim());
        if ($btn.length) $btn.attr('data-selected-value', ($item.attr('data-value') || '').trim().toLowerCase());
        if ($menu.length) $menu.removeClass('show');

        filterJobs();
    });

    function filterJobs() {
        const department = (departmentBtn.length ? (departmentBtn.attr('data-selected-value') || '') : '').trim().toLowerCase();
        const location = (locationBtn.length ? (locationBtn.attr('data-selected-value') || '') : '').trim().toLowerCase();

        filteredRows = [];

        allRows.forEach(row => {
            const dep = (row.dataset.department || '').trim().toLowerCase();
            const loc = (row.dataset.location || '').trim().toLowerCase();

            const departmentMatch = !department || dep === department;
            const locationMatch = !location || loc === location;

            if (departmentMatch && locationMatch) {
                filteredRows.push(row);
            }
        });

        currentPage = 1;
        updatePagination();
        handleNoJobsRow(filteredRows.length);
    }

    function updatePagination() {
        const totalPages = Math.ceil(filteredRows.length / rowsPerPage) || 1;

        if (currentPage > totalPages) {
            currentPage = totalPages;
        }

        currentPageEl.textContent = currentPage;
        totalPagesEl.textContent = totalPages;

        allRows.forEach(row => {
            row.hidden = true;
        });

        const start = (currentPage - 1) * rowsPerPage;
        const end = start + rowsPerPage;

        filteredRows.slice(start, end).forEach(row => {
            row.hidden = false;
        });

        paginationContainer.style.display = filteredRows.length > rowsPerPage ? 'flex' : 'none';

        prevBtn.disabled = currentPage === 1;
        nextBtn.disabled = currentPage === totalPages;
    }

    prevBtn.addEventListener('click', function () {
        if (currentPage > 1) {
            currentPage--;
            updatePagination();
        }
    });

    nextBtn.addEventListener('click', function () {
        currentPage++;
        updatePagination();
    });

    function handleNoJobsRow(visibleCount) {
        if (noJobsRow) {
            noJobsRow.hidden = visibleCount > 0;
        }
    }

    filterJobs();
}

